module.exports = __webpack_public_path__ + "static/media/Fitzgerald.ac55fff5.png";